import React from "react"
import tw, { styled } from "twin.macro"

const Wrapper = styled.div`
    ${tw`rounded-md bg-gray-400 m-2 px-2 pb-2 overflow-hidden`}
`

const Container = styled.div`
	${tw`container flex flex-row flex-wrap bg-gray-300`}
`

const GroupName = styled.div`
	${tw`text-lg font-bold`}
`

const Attribute = styled.div`
	${tw`mx-4 text-lg`}
`

const AttributeValue = styled.div`
	${tw`text-base`}
`

const PositiveValue = styled(AttributeValue)`
	${tw`text-green-500 font-bold`}
`

const NegativeValue = styled(AttributeValue)`
	${tw`text-red-600 font-bold`}
`

const Title = styled.div`
	${tw`flex flex-row content-center justify-between bg-gray-400 w-full p-2`}
`

const Name = styled.div`
	${tw`text-xl font-bold`}
`

const Specifications = styled.div`
	${tw`flex flex-col content-center w-full p-2 text-xl`}
`

const Col = styled.td`
	${tw`w-1/2`}
`

const ProductSpecifications = ({ specifications }) => {
	return (
        <Wrapper>
		    <Container>
                <Title>
                    <Name>
                        Specifications
                    </Name>
                </Title>
                <Specifications>
                    <table>
                        {specifications.map((group) => (
                            <>
                            <tr>
                                <Col><GroupName>{group.groupName}</GroupName></Col>
                                <Col></Col>
                            </tr>
                            {group.attributesArray.map((attribute) => (
                                <tr>
                                    <Col><Attribute>{attribute.name}:</Attribute></Col>
                                    <Col>
                                    {attribute.highlight === "positive" ?
                                            <PositiveValue>{attribute.value}</PositiveValue>
                                            :
                                            ""
                                        }
                                        {attribute.highlight === "negative" ?
                                            <NegativeValue>{attribute.value}</NegativeValue>
                                            :
                                            ""
                                        }
                                        {attribute.highlight !== "positive" && attribute.highlight !== "negative" ?
                                            <AttributeValue>{attribute.value}</AttributeValue>
                                            :
                                            ""
                                        }
                                    </Col>
                                </tr>
                            ))}
                            </>
                        ))}
                    </table>
                </Specifications>
		    </Container>
        </Wrapper>
	)
}

export default ProductSpecifications